export default __webpack_public_path__ + "static/media/logo.fd362365.png";